const fields = [
	{name: "medrecord_data", label: "Медицинские данные", type: "file", required: false},
];

const initialValues = {
	medrecord_data: undefined,
};

export {fields, initialValues};